import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import Card from "../../../../../components/Card/Card";
import ContentLoader from "components/loader/ContentLoader";

const DonutChart = ({ piechartData, isLoading = false }) => {
    const [chartData, setChartData] = useState([]);
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        setChartData(piechartData.numbers);
        setChartOptions({
            series: [50, 15, 10, 20, 5],
            labels: piechartData.types,
            colors: ["#00cdcd", "#009a9a", "#006767", "#004d4d", "#003434"],
            chart: {
                width: "100%"
            },
            states: {
                hover: {
                    filter: {
                        type: "none"
                    }
                }
            },
            legend: {
                show: true
            },
            dataLabels: {
                enabled: true
            },
            hover: { mode: null },
            plotOptions: {
                donut: {
                    expandOnClick: false,
                    donut: {
                        labels: {
                            show: false
                        }
                    }
                }
            },
            fill: {
                colors: ["#00cdcd", "#009a9a", "#006767", "#004d4d", "#003434"]
            },
            tooltip: {
                enabled: true,
                theme: "dark"
            }
        });
    }, [piechartData]);

    return (
        <Card p='28px 10px 16px 0px' mb={{ sm: "26px", lg: "0px" }}>
            {isLoading ? (
                <ContentLoader minH={{ sm: "300px", lg: "340px" }} label='Loading chart...'/>
            ) : chartData?.length > 0 ? (
                <ReactApexChart
                    options={chartOptions}
                    series={chartData}
                    type="donut"
                    width="80%"
                    height="80%"
                />
            ) : null}
        </Card>
    );
};

export default DonutChart;
